import { render, staticRenderFns } from "./IcoAppearance.vue?vue&type=template&id=22263ac2&scoped=true"
import script from "./IcoAppearance.vue?vue&type=script&lang=js"
export * from "./IcoAppearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22263ac2",
  null
  
)

export default component.exports